(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sapphire-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector('[data-sb-motion-toggle]');
    if (!button || button.dataset.ready) return;
    button.dataset.ready = 'true';
    button.addEventListener('click', () => {
      const paused = document.body.classList.toggle('sb-motion-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.querySelector('.sb-motion-pause').hidden = paused;
      button.querySelector('.sb-motion-resume').hidden = !paused;
    });
    const syncVisibility = () => document.body.classList.toggle('sb-motion-background', document.hidden);
    document.addEventListener('visibilitychange', syncVisibility);
    syncVisibility();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["states-advanced-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-facet-group], [data-facet-remove], [data-facet-reset], [data-stock-only], [data-native-filter]');
    if (!link) return;
    const root = link.closest('[data-states-facets]');
    if (!root) return;
    event.preventDefault();
    if (link.hasAttribute('data-stock-only')) {
      const filtered = new URL(window.location.href);
      if (filtered.searchParams.get('filter.v.availability') === '1') {
        filtered.searchParams.delete('filter.v.availability');
      } else {
        filtered.searchParams.set('filter.v.availability', '1');
      }
      filtered.searchParams.delete('page');
      window.location.assign(filtered.href);
      return;
    }
    if (link.hasAttribute('data-native-filter')) {
      const summary = document.querySelector('.facets--horizontal accordion-custom[data-filter-param-name="filter-v-price"] summary');
      if (summary && summary.getClientRects().length) {
        summary.click();
        summary.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } else {
        document.querySelector('.facets-toggle__button')?.click();
      }
      return;
    }
    const url = new URL(root.dataset.collectionUrl, window.location.origin);
    const selected = [...root.querySelectorAll('[data-facet-group].is-active')].map((element) => ({
      group: element.dataset.facetGroup,
      handle: element.dataset.facetHandle
    }));
    const changedGroup = link.dataset.facetGroup || link.dataset.facetRemove;
    let next = selected.filter((item) => item.group !== changedGroup);
    if (link.dataset.facetGroup && !link.classList.contains('is-active')) {
      next.push({ group: changedGroup, handle: link.dataset.facetHandle });
    }
    if (link.hasAttribute('data-facet-reset')) next = [];
    if (next.length) url.pathname += '/' + next.map((item) => item.handle).join('+');
    url.search = window.location.search;
    url.searchParams.delete('page');
    window.location.assign(url.href);
  });
  if (new URL(window.location.href).searchParams.get('filter.v.availability') === '1') {
    document.querySelector('[data-stock-only]')?.setAttribute('aria-pressed', 'true');
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["states-launch-gate"] && !Shopify.designMode) return;
  try {
    (function () {
      const root = document.getElementById('sb-premiere-v2');
      if (!root) return;
      const key = 'states-bazaar-premiere-15-v2';
      const forced = new URLSearchParams(location.search).get('premiere') === '1';
      let cameFromStore = false;
      try { cameFromStore = Boolean(document.referrer && new URL(document.referrer).origin === location.origin); } catch (error) { }
      if (cameFromStore && !forced) return;

      root.hidden = false;
      document.body.classList.add('sb-premiere-locked');
      const skip = root.querySelector('.sb-premiere__skip');
      const countdowns = [...root.querySelectorAll('[data-release]')];
      let previousFocus = document.activeElement;
      let closed = false;
      const startedAt = performance.now();
      const duration = 15000;
      skip.focus({ preventScroll: true });

      function update() {
        countdowns.forEach((counter) => {
          const left = Math.max(0, new Date(counter.dataset.release).getTime() - Date.now());
          const values = {
            days: Math.floor(left / 86400000),
            hours: Math.floor(left / 3600000) % 24,
            minutes: Math.floor(left / 60000) % 60,
            seconds: Math.floor(left / 1000) % 60
          };
          Object.entries(values).forEach(([unit, value]) => {
            const node = counter.querySelector(`[data-unit="${unit}"]`);
            if (node) node.textContent = String(value).padStart(unit === 'days' ? 3 : 2, '0');
          });
        });
        const remaining = Math.max(0, Math.ceil((duration - (performance.now() - startedAt)) / 1000));
        root.querySelector('.sb-premiere__remaining').textContent = String(remaining).padStart(2, '0');
        if (!remaining) close();
      }
      function close() {
        if (closed) return;
        closed = true;
        clearInterval(interval);
        try { sessionStorage.setItem(key, '1'); } catch (error) { }
        root.classList.add('is-leaving');
        document.body.classList.remove('sb-premiere-locked');
        setTimeout(() => {
          root.remove();
          if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
        }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 800);
      }
      skip.addEventListener('click', close);
      root.addEventListener('click', (event) => {
        if (event.target.closest('a')) {
          try { sessionStorage.setItem(key, '1'); } catch (error) { }
        }
      });
      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
        if (event.key !== 'Tab') return;
        const focusable = [...root.querySelectorAll('button, a[href]')];
        if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable.at(-1).focus(); }
        else if (!event.shiftKey && document.activeElement === focusable.at(-1)) { event.preventDefault(); focusable[0].focus(); }
      });
      update();
      const interval = setInterval(update, 250);
    })();
  } catch(e) { console.error(e); }
})();

})();
